import React, { useState, useEffect } from 'react';
import { useAdminData } from '../contexts/AdminDataContext';
import './AutoRefreshIndicator.css';

const AutoRefreshIndicator = () => {
  const { lastRefresh, refreshInterval } = useAdminData();
  const [timeUntilRefresh, setTimeUntilRefresh] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!lastRefresh) return;

    const updateCountdown = () => {
      const now = new Date();
      const timeSinceRefresh = now - lastRefresh;
      const timeLeft = refreshInterval - timeSinceRefresh;
      
      if (timeLeft > 0) {
        setTimeUntilRefresh(Math.ceil(timeLeft / 1000));
      } else {
        setTimeUntilRefresh(0);
      }
    };

    // Update immediately
    updateCountdown();

    // Update every second
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [lastRefresh, refreshInterval]);

  // Show indicator briefly when data refreshes
  useEffect(() => {
    if (lastRefresh) {
      setIsVisible(true);
      const timer = setTimeout(() => setIsVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [lastRefresh]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="auto-refresh-indicator">
      {/* Refresh notification */}
      {isVisible && (
        <div className="refresh-notification">
          <i className="fas fa-sync-alt fa-spin"></i>
          <span>زانیارییەکان نوێکرانەوە</span>
        </div>
      )}
      
      {/* Countdown timer */}
      <div className="refresh-timer" title="کاتی ماوە بۆ نوێکردنەوەی داتا">
        <i className="fas fa-clock"></i>
        <span>{formatTime(timeUntilRefresh)}</span>
      </div>

    </div>
  );
};

export default AutoRefreshIndicator;
